import React from 'react'
import PropTypes from 'prop-types'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { StyledButton } from 'ui/styled/Buttons'
import CarePlan from 'model/carePlans/carePlan'
import Pdf from './Pdf'

const RoadmapPdf = ({ carePlan, style = {}, buttonAction = () => {} }) => (
  <PDFDownloadLink
    document={<Pdf carePlan={carePlan} />}
    fileName={`careplan_${carePlan?.title}.pdf`}
  >
    {({ loading }) => (
      <StyledButton
        btnsize="custom"
        padding="8px 12px"
        margin="0 24px 0 0"
        data-test="carePlanExportBtn"
        disabled={loading}
        loading={loading}
        onClick={buttonAction}
        style={style}
      >
        Export
      </StyledButton>
    )}
  </PDFDownloadLink>
)

RoadmapPdf.propTypes = {
  carePlan: PropTypes.shape(CarePlan.shape).isRequired,
  style: PropTypes.object,
  buttonAction: PropTypes.func
}

export default RoadmapPdf
